const COLOUR_HEX = {
  black: "#111111",
  white: "#FFFFFF",
  red: "#E52E39",
  navy: "#0A2540",
  blue: "#2563EB",
  grey: "#9CA3AF",
  gray: "#9CA3AF",
  green: "#1F5E3D",
  yellow: "#F5C518",
  gold: "#D4AF37",
  pink: "#F9A8D4",
  brown: "#7C4A21",
  beige: "#E8DCC3",
  cream: "#F5F0E1",
  orange: "#F97316",
  purple: "#8B5CF6",
  burgundy: "#7B1E3A",
  khaki: "#BDB76B",
  olive: "#6B7A3A",
  charcoal: "#36454F",
};

export const colourHex = (name) => COLOUR_HEX[(name || "").trim().toLowerCase()] || "#D8D2C4";
